/**
 * Note: FabricAnnotationType.pin (地图内置, 需要传递 `pinColor`)
 */
export enum FabricAnnotationType {
  /**
   * 点标注
   */
  image = 'image',

  /**
   * 大头针标注, 地图内置.
   */
  pin = 'pin',

  /**
   * 动画标注
   */
  animation = 'animation',
}

/**
 * 标柱的动画效果配置
 */
export enum FabricAnnotationAnimationType {
  /**
   * 无动画
   */
  none = 'none',

  /**
   * 移动动画，主要用于司机卡车移动,  只有更新已有标注才有效
   */
  move = 'move',
}

/**
 *  气泡停靠在标记点的方位.
 *  - top - 停靠在标记点上方
 *  - right - 停靠在标记点右边
 *  - bottom - 停靠在标记点底边
 *  - left - 停靠在标记点左边
 *  - 默认值： top
 */
export enum CalloutRichTextDockDirection {
  top = 'top',
  right = 'right',
  bottom = 'bottom',
  left = 'left',
}
